import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=3152f873&scoped=true"
import script from "./arrow.vue?vue&type=script&lang=js"
export * from "./arrow.vue?vue&type=script&lang=js"
import style0 from "./arrow.vue?vue&type=style&index=0&id=3152f873&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152f873",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3152f873')) {
      api.createRecord('3152f873', component.options)
    } else {
      api.reload('3152f873', component.options)
    }
    module.hot.accept("./arrow.vue?vue&type=template&id=3152f873&scoped=true", function () {
      api.rerender('3152f873', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformActivity/components/arrow.vue"
export default component.exports